<template>
    <div class="base-password-input">
        <label v-if="label">{{ label }}</label>
        <div class="input-group">
            <input
                class="form-control" :class="inputClasses"
                type="text"
                v-bind:value="value"
                v-on:input="$emit('input', $event.target.value)"
            />
            <span class="input-group-btn">
                <button class="btn btn-default" type="button" :class="`btn-${size}`" content="Show / hide password" v-tippy="{arrow: true, placement: 'top-right'}" @click="onPasswordVisiblity">
                    <i class="fas" :class="{'fa-eye': passwordFieldType === 'text', 'fa-eye-slash': passwordFieldType === 'password'}"></i>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BasePasswordInput',
    props: {
        value: {
            type: String,
        },
        size: {
            type: String,
            default: 'md',
            validator(value) {
                return ['sm', 'md', 'lg'].indexOf(value) !== -1;
            },
        },
        label: {
            type: String,
        },
    },
    data() {
        return {
            passwordFieldType: 'password',
        };
    },
    watch: {
        type(newValue) {
            this.passwordFieldType = newValue;
        },
    },
    computed: {
        inputClasses() {
            return {
                'input-sm': this.size === 'sm',
                'input-md': this.size === 'md',
                'input-lg': this.size === 'lg',
                'is-masked': this.passwordFieldType === 'password',
            }
        },
    },
    methods:{
        onPasswordVisiblity() {
            this.passwordFieldType = (this.passwordFieldType === 'password') ? 'text' : 'password';
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.base-password-input {

    .input-group input {
        border: 1px solid $gray-light;
    }

    input.is-masked {
        text-security: disc;
        -webkit-text-security: disc;
        -mox-text-security: disc;
    }

    .input-group-addon {
        cursor: pointer;
    }
}
</style>
